// eslint-disable-next-line import/prefer-default-export
export const alertSeverityColors = {
    low: 'primary',
    medium: 'warning',
    high: 'danger',
};
